// File#: _mega-products-menu
// Enhances the mega menu "Produkte" navigation with a multi-level drilldown.

(function () {
  function getTextFromEl(el) {
    return el ? (el.textContent || '').trim() : '';
  }

  function renderList(listEl, terms) {
    var html = '';

    for (var i = 0; i < terms.length; i++) {
      var term = terms[i];
      if (!term) continue;

      var hasChildren = !!term.has_children;

      html += '<li class="mega-products-nav__item">';
      html +=
        '<a class="mega-products-nav__link" href="' +
        String(term.link || '#') +
        '">' +
        String(term.name || '') +
        '</a>';

      if (hasChildren) {
        html +=
          '<button class="reset mega-products-nav__drill js-mega-products-nav__drill" type="button" data-term-id="' +
          String(term.id) +
          '" aria-label="Unterkategorien öffnen">' +
          '<svg class="icon" viewBox="0 0 16 16" aria-hidden="true">' +
          '<g stroke-width="1" stroke="currentColor">' +
          '<polyline fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="6.5,3.5 11,8 6.5,12.5 "></polyline>' +
          '</g>' +
          '</svg>' +
          '</button>';
      }

      html += '</li>';
    }

    listEl.innerHTML = html;
  }

  function setCurrentLabel(navEl, label) {
    var currentEl = navEl.querySelector('.js-mega-products-nav__current');
    if (currentEl) currentEl.textContent = label;
  }

  function setBackVisibility(navEl, isVisible) {
    var backBtn = navEl.querySelector('.js-mega-products-nav__back');
    if (!backBtn) return;
    if (isVisible) {
      backBtn.removeAttribute('hidden');
    } else {
      backBtn.setAttribute('hidden', '');
    }
  }

  function animateSlide(navEl, direction) {
    // direction: "forward" | "back"
    navEl.classList.remove('mega-products-nav--slide-forward', 'mega-products-nav--slide-back');
    // force reflow so animation restarts
    // eslint-disable-next-line no-unused-expressions
    navEl.offsetHeight;
    navEl.classList.add(direction === 'back' ? 'mega-products-nav--slide-back' : 'mega-products-nav--slide-forward');
  }

  function fetchChildren(endpoint, taxonomy, parentId) {
    if (!endpoint || !taxonomy) return Promise.resolve([]);

    var url = new URL(endpoint, window.location.origin);
    url.searchParams.set('taxonomy', taxonomy);
    url.searchParams.set('parent', String(parentId || 0));

    return window
      .fetch(url.toString(), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
      })
      .then(function (res) {
        if (!res.ok) return [];
        return res.json();
      })
      .then(function (data) {
        return Array.isArray(data) ? data : [];
      })
      .catch(function () {
        return [];
      });
  }

  function initMegaProductsNav(navEl) {
    var taxonomy = navEl.getAttribute('data-products-taxonomy');
    var endpoint = navEl.getAttribute('data-products-endpoint');
    if (!taxonomy || !endpoint) return;

    var listEl = navEl.querySelector('.js-mega-products-nav__list');
    if (!listEl) return;

    // Store the server-rendered root list so it can be restored when navigating back to level 1.
    var rootListHtml = listEl.innerHTML;

    var stack = [
      {
        id: 0,
        label: 'Kategorien',
        terms: null, // keep server-rendered HTML for level 0
      },
    ];

    var cache = {}; // parentId -> terms[]

    function goToLevel(level) {
      var state = stack[level];
      if (!state) return;

      if (level === 0) {
        // Level 0 is server-rendered.
        listEl.innerHTML = rootListHtml;
        setCurrentLabel(navEl, state.label || 'Kategorien');
        setBackVisibility(navEl, false);
        return;
      }

      renderList(listEl, state.terms || []);
      setCurrentLabel(navEl, state.label || 'Kategorien');
      setBackVisibility(navEl, level > 0);
    }

    // Initial render is already server-side, but keep it in sync.
    goToLevel(0);

    navEl.addEventListener('click', function (event) {
      var drillBtn = event.target.closest('.js-mega-products-nav__drill');
      if (drillBtn) {
        event.preventDefault();
        event.stopPropagation();

        var termId = parseInt(drillBtn.getAttribute('data-term-id'), 10);
        if (!termId) return;

        var parentLabel = '';
        var parentItem = drillBtn.closest('.mega-products-nav__item');
        if (parentItem) {
          var link = parentItem.querySelector('.mega-products-nav__link');
          parentLabel = getTextFromEl(link);
        }

        var useCached = Array.isArray(cache[termId]);
        var load = useCached ? Promise.resolve(cache[termId]) : fetchChildren(endpoint, taxonomy, termId);

        load.then(function (terms) {
          cache[termId] = terms;
          stack.push({
            id: termId,
            label: parentLabel || 'Kategorien',
            terms: terms,
          });

          animateSlide(navEl, 'forward');
          goToLevel(stack.length - 1);
        });
        return;
      }

      var backBtn = event.target.closest('.js-mega-products-nav__back');
      if (backBtn) {
        event.preventDefault();
        event.stopPropagation();

        if (stack.length <= 1) return;
        stack.pop();

        animateSlide(navEl, 'back');
        if (stack.length === 1) {
          // Restore the original root list markup.
          listEl.innerHTML = rootListHtml;
          setCurrentLabel(navEl, 'Kategorien');
          setBackVisibility(navEl, false);
        } else {
          goToLevel(stack.length - 1);
        }
      }
    });
  }

  var navs = document.getElementsByClassName('js-mega-products-nav');
  if (!navs || navs.length === 0) return;

  for (var i = 0; i < navs.length; i++) {
    initMegaProductsNav(navs[i]);
  }
})();


